
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [
    {	
		name: "item_id", 
		value:'', 		
		id:'inventory_form_item_id',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "item_unit_id", 
		value:'', 		
		id:'inventory_form_item_unit_id',
		html:'',
		type:'textfield',
		required: false,  
	},
];



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 

